import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import threatDashboardImg from "../img/threat-dashboard.png";

export const Hero = () => {
  return (
    <section className="position-relative overflow-hidden mb-4" style={{ minHeight: "320px", backgroundColor: "#ffffff" }}>
      {/* Orange diagonal background - contained in hero, hidden on mobile */}
      <div
        className="position-absolute top-0 end-0 h-100 d-none d-lg-block"
        style={{
          width: "45%",
          backgroundColor: "#f98e00",
          clipPath: "polygon(30% 0, 100% 0, 100% 100%, 10% 100%)",
          zIndex: 0,
        }}
      ></div>

      <Container fluid style={{ maxWidth: "1400px", position: "relative", zIndex: 1 }}>
        <Row className="align-items-center py-5">
          <Col lg={7} className="py-4">
            <div className="mb-5 pb-3">
              <a href="https://lumu.io">
                <img
                  src="https://lumu.io/wp-content/uploads/2020/01/lumu-color.png"
                  width="140"
                  height="52"
                  alt="Lumu"
                  style={{ maxWidth: "140px", height: "auto" }}
                />
              </a>
            </div>
            <h1 className="display-4 fw-bold text-dark mb-3">
              Lumu's{" "}
              <span
                className="text-white px-2"
                style={{ backgroundColor: "#f98e00" }}
              >
                Tradecraft
              </span>
            </h1>
            <p className="lead text-secondary open-sans" style={{ maxWidth: "600px" }}>
              In the world of espionage, Tradecraft refers to specialized techniques
              and procedures used in clandestine operations to gather intelligence
              and conduct surveillance without detection. Take a look at some of the
              techniques that Lumu deploys in real time to outsmart adversaries and
              better defend you.
            </p>
          </Col>
          <Col lg={5} className="d-none d-lg-flex align-items-center justify-content-center">
            <Image
              src={threatDashboardImg}
              alt="Threat Dashboard"
              fluid
              style={{
                maxHeight: "750px",
                objectFit: "contain",
              }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
